// extracted by mini-css-extract-plugin
export var root = "styles-module--root--3kfcF";
export var title = "styles-module--title--2M8YY";
export var itemGrid = "styles-module--item-grid--3GOXU";